<style type="text/scss" lang="scss">
  @import '../../styles/vars';
  .input-date :global(input) {
    appearance: none;
    background: #f7f7f8;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    font-family: 'Lato', sans-serif;
    color: #1c1c1b;
    font-weight: 500;
    font-size: 15px;
    margin: 0;
  }

  .input-date::focus {
    outline: none;
    border: none;
    box-shadow: none;
    background-color: darken(#f7f7f8, 2);
  }

  .clear {
    position: absolute;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 10px;
    top: 0;
    cursor: pointer;
  }

  .clear-inner img {
    height: 10px;
    width: 10px;
  }

  .clear-inner {
    height: 22px;
    width: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #efefef;
  }

  .input-date-inner {
    position: relative;
  }
</style>

<script>
  import Flatpickr from 'svelte-flatpickr';
  import flatpickr from 'flatpickr';
  import moment from 'moment';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let value, formattedValue;
  export let id;
  export let label = null;
  export let placeholder = '';
  export let readonly = false;


  value = value
  formattedValue = value ? moment(value).format('h:mm A') : null

  let pickrOptions = {
    enableTime: true,
    noCalendar: true,
    altInput: true,
    altFormat: 'h:i K',
    dateFormat: 'h:i K',
    defaultDate: null,
  };

  function handleChange(event) {
    const [selectedDates, dateStr] = event.detail;
  }

  function clear() {
    value = null;
    formattedValue = null
  }
</script>

<div class="input-date">
  <!-- LABEL -->
  {#if label}<label>{label}</label>{/if}
  <!-- COMPONENT -->
  <div class="input-date-inner">
    <Flatpickr id="{id}" on:input on:change options="{pickrOptions}" bind:value bind:formattedValue
      placeholder="{placeholder}">
    </Flatpickr>
    {#if value}
    <span on:click="{clear}" class="clear">
      <div class="clear-inner">
        <img src="/static/icons/close.png" />
      </div>
    </span>
    {/if}
  </div>
</div>